<div class="cart-rec">
    <div class="cr-items" #container>
        <div class="cr-item" [style.min-width.px]="w" *ngFor="let item of items">
            <cat-item [item]="item" [hoverable]="false" [compact]="true"></cat-item>
        </div>  
    </div>
</div>
